T.SocialIcons = function ( type ) {
	let els = [];
	const socials = [
		'fb',
		'ig',
		'tk',
		'yt',
		'in'
	];
	for( let i = 0; i < socials.length; i++ ) {
		const social = socials[i];
		els.push({
			tag: 'a',
			target: '_blank',
			className: 'social-icon social-icon-' + social,
			href: D.Lang.get(`socials.${social}.url`, D.Lang.get(`socials.${social}.url`, null, 'en'))
		});
	}
	return mkE({
		tag: 'div',
		className: 'social-icons',
		els: [
			{
				tag: 'h2',
				text: D.Lang.get('home.socials.title')
			},
			{
				tag: 'p',
				text: D.Lang.get('home.socials.text')
			},
			{
				tag: 'div',
				className: 'icons',
				els: els
			}
		]
	});
};